export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="font-heading text-xl md:text-2xl text-accent-400 block mb-4">
              51影视
            </span>
            <p className="text-xs md:text-sm text-white/60 leading-relaxed">
              51影视网致力于为广大剧迷提供电视剧全集免费在线观看服务。
              高清画质、极速缓冲、纯净无广告，让追剧变得更加简单快乐。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">热播榜单</a>
              <a href="#index" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">专题索引</a>
              <a href="#topics" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">话题热议</a>
              <a href="#faq" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">剧集分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">国产剧</a>
              <a href="#index" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">港台剧</a>
              <a href="#index" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">日韩剧</a>
              <a href="#index" className="text-xs md:text-sm text-white/60 hover:text-accent-400 transition-colors cursor-pointer">欧美剧</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-white/40 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} 51影视网. 本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-white/40 hover:text-accent-400 transition-colors cursor-pointer">回到顶部</a>
              <a href="#contact" className="text-xs text-white/40 hover:text-accent-400 transition-colors cursor-pointer">联络我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}